import { Store } from '@ms/yammer-data/dist/state/types';
import Main from 'components/Main';
import React from 'react';
import { render } from 'react-dom';
import { YammerTeamsState } from 'state/types';

interface RendererOptions {
  readonly store: Store<YammerTeamsState>;
  readonly target: HTMLElement;
  readonly error?: unknown;
}

export type Renderer = (options: RendererOptions) => void;

const renderer: Renderer = ({ store, target, error }) => {
  render(<Main store={store} error={error} />, target);
};

export default renderer;
